import { createContext } from "react";

export const LogisticStationContext = createContext({
  logisticStation: {},
  onChange: () => {},
});
